import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { coins } from "../../constants/constants";
import { useUser } from "../../context/user-context";
import PortionAmount from "../../components/PortionAmount";
import { formatAmount } from "../../utils/formatTime";
import { useMutation, useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { API } from "../../constants/api";
import { errorMessage } from "../../utils/errorMessage";
import useAuthAxios from "../../utils/baseAxios";
import ClipLoader from "react-spinners/ClipLoader";
import { useApiAssets } from "../../hooks/useApiAssets";

const SwapCoin = ({
  setOpenSwap,
  setOpenSwapPreview,
  selectedCoinObjj,
  selectedCoinToObj,
  setSelectedCoinToObj,
  selectedCoinFromObj,
  setSelectedFromCoinObj,
  recieveAmount,
  setReceiveAmount,
  setFeeAmount,
  setOrderID,
  amount,
  setAmount,
}: any) => {
  const { userDetails } = useUser();
  const walletBalances = userDetails?.user.deexWalletBalances;
  const [coinBalancee, setCoinBalancee] = useState<number | null>(null);
  const [coinBalanceeTo, setCoinBalanceeTo] = useState<number | null>(null);
  const [disabled, setDisabled] = useState<boolean>(false);

  const axiosInstance = useAuthAxios();
  const { toApiAsset, isOffered } = useApiAssets();

  // Only offer what this environment can actually quote.
  const swappableCoins = coins.filter((coin: any) => isOffered(coin.abbr));
  const isNumber = (str: any) => {
    if (str.trim() === "") {
      return false;
    }

    return !isNaN(str);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (isNumber(value)) {
      setAmount(value);
    } else {
      setAmount("");
    }
  };

  const handleCoinChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedAbbr = e.target.value;
    const selectedAbbrLC = selectedAbbr.toLowerCase();
    const coin = coins.find((coin: any) => coin.abbr === selectedAbbr);

    setSelectedFromCoinObj(coin);
    setReceiveAmount(""); // Set the selected 'from' coin
    const coinBalance = walletBalances[selectedAbbrLC];

    if (coinBalance !== undefined) {
      setCoinBalancee(coinBalance);
    }

    // Reset the 'to' coin if the new selection changes the rules
    if (selectedAbbr !== "USDT") {
      setSelectedCoinToObj(coins.find((c: any) => c.abbr === "USDT"));
    } else {
      setSelectedCoinToObj(null); // Reset for user to select other coins except USDT
    }
  };

  const handleCoinToChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedAbbr = e.target.value;
    const coin = coins.find((coin: any) => coin.abbr === selectedAbbr);

    setSelectedCoinToObj(coin); // Update the selected "To" coin
    setReceiveAmount("");
    const balance = getCoinBalance(selectedAbbr); // Fetch the balance
    setCoinBalanceeTo(balance);
  };

  const getCoinBalance = (abbr: string) => {
    const lowerAbbr = abbr.toLowerCase();
    return walletBalances ? walletBalances[lowerAbbr] : 0;
  };
  useEffect(() => {
    if (selectedCoinToObj) {
      const balance = getCoinBalance(selectedCoinToObj.abbr);
      setCoinBalanceeTo(balance);
    }
  }, [selectedCoinToObj]);

  useEffect(() => {
    if (selectedCoinObjj) {
      setSelectedFromCoinObj(selectedCoinObjj); // Set pre-selected coin
      const selectedAbbr = selectedCoinObjj?.abbr;
      const selectedAbbrLC = selectedCoinObjj?.abbr.toLowerCase();
      const coin = coins.find((coin: any) => coin.abbr === selectedAbbr);
      setSelectedFromCoinObj(coin);
      setReceiveAmount("");
      const coinBalance = walletBalances[selectedAbbrLC];

      if (coinBalance !== undefined) {
        setCoinBalancee(coinBalance);
        // Here, you can display the balance in the UI, like updating state
      } else {
      }
    } else {
    }
  }, [selectedCoinObjj, walletBalances]);
  console.log(coinBalancee);
  console.log(amount);
  const isBalanceSufficient = Number(amount) <= Number(coinBalancee);

  const fromAssetCode = toApiAsset(selectedCoinFromObj?.abbr);
  const toAssetCode = toApiAsset(selectedCoinToObj?.abbr);

  const getQuote = async () => {
    const response = await axiosInstance.get(
      API.getConversionRate(fromAssetCode, toAssetCode, Number(amount))
    );
    return response.data;
  };

  const {
    data: swapQuote,
    error: error1,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [
      "get-swap-quote",
      fromAssetCode,
      toAssetCode,
      isBalanceSufficient,
      amount,
    ],
    queryFn: getQuote,
    enabled:
      !!selectedCoinFromObj?.abbr &&
      !!selectedCoinToObj?.abbr &&
      !!isBalanceSufficient &&
      !!amount,
    retry: 1,
  });

  useEffect(() => {
    if (error1) {
      const newError = error1 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error1]);

  // const completeQuote = useMutation({
  //   mutationFn: getQuote,
  //   onSuccess: (r) => {
  //     // console.log(r);
  //     setReceiveAmount(r?.data?.order?.receive?.amount);
  //     setFeeAmount(r?.data?.order?.fee?.amount);
  //     setOrderID(r?.data?.order?.id);
  //     // toast.success(r.message);
  //   },
  //   onError: (error: any) => {
  //     toast.error(
  //       errorMessage((error?.data as any)?.message || String(error?.data))
  //     );
  //   },
  // });
  useEffect(() => {
    if (swapQuote) {
      setReceiveAmount(swapQuote?.data?.amountReceived);
      setFeeAmount(swapQuote?.data?.exchange_fee?.flat);
    }
  }, [swapQuote]);
  useEffect(() => {
    if (
      !selectedCoinFromObj?.abbr ||
      !amount ||
      !selectedCoinToObj?.abbr ||
      !isBalanceSufficient ||
      !recieveAmount
    ) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [
    amount,
    coinBalancee,
    isBalanceSufficient,
    selectedCoinFromObj?.abbr,
    selectedCoinToObj?.abbr,
    recieveAmount,
  ]);

  // console.log(swapQuote);

  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-4 items-center">
          <button
            onClick={() => {
              setOpenSwap(false);
              setSelectedCoinToObj(null);
              setSelectedFromCoinObj(null);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Swap {selectedCoinFromObj?.name}
          </h4>
        </div>
        <div className="w-full mt-8">
          <div className="w-full py-6 border-b border-b-gray-200 dark:border-gray-600">
            <div className="flex justify-between gap-4 items-start">
              <div className="w-2/5">
                <h4 className="text-[13px] text-gray-700 dark:text-gray-300">
                  From
                </h4>
                <div className="h-[48px] mt-2 rounded-xl border border-gray-300 dark:border-gray-600 px-2 flex gap-1 justify-start items-center">
                  {selectedCoinFromObj?.logo && (
                    <div className="flex justify-center items-center  w-[24px] h-[20px] rounded-full">
                      <img
                        src={
                          selectedCoinFromObj?.logo
                            ? selectedCoinFromObj?.logo
                            : ""
                        }
                        className="w-full h-full bg-cover"
                        alt=""
                      />
                    </div>
                  )}

                  <select
                    value={selectedCoinFromObj?.abbr || ""}
                    onChange={handleCoinChange}
                    className="outline-none w-full text-[14px] bg-transparent text-gray-800 dark:text-gray-200"
                  >
                    <option value="" disabled>
                      Select a coin
                    </option>
                    {swappableCoins.map((coin: any, index: any) => (
                      <option key={index} value={coin.abbr}>
                        {coin.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="w-3/5 mt-5">
                <div className="h-[48px] mt-2 rounded-xl border border-gray-300 dark:border-gray-600 px-2  flex gap-1 justify-between items-center">
                  <input
                    type="number"
                    placeholder="Amount"
                    value={amount}
                    onChange={handleChange}
                    className="text-gray-700 dark:text-gray-300 w-full spin-button-none bg-transparent text-[13px] text-left outline-none"
                  />
                  <h4 className="text-[13px] font-bold text-secondary_button">
                    {" "}
                    {selectedCoinFromObj?.abbr}
                  </h4>
                </div>
                {!isBalanceSufficient && (
                  <h4 className="text-red-600 font-bold mt-1 text-[10px] ">
                    Insufficient funds
                  </h4>
                )}
              </div>
            </div>
            <div className="flex mt-3 justify-between items-center">
              {coinBalancee !== null && coinBalancee !== undefined && (
                <h4 className="text-center mt-2 text-[13px] font-medium text-gray-700 dark:text-gray-300">
                  Balance:
                  <span className="text-green-700">
                    {formatAmount(coinBalancee)}{" "}
                    {setSelectedFromCoinObj?.abbr || ""}
                  </span>
                </h4>
              )}
              <PortionAmount setAmount={setAmount} coinBalance={coinBalancee} />
            </div>
          </div>
          {/* Swap direction button */}
          <div className="relative w-full flex justify-center -my-3 z-10">
            <button
              onClick={() => {
                if (!selectedCoinFromObj || !selectedCoinToObj) return;
                const tempFrom = selectedCoinFromObj;
                const tempTo = selectedCoinToObj;
                setSelectedFromCoinObj(tempTo);
                setSelectedCoinToObj(tempFrom);
                setAmount("");
                setReceiveAmount("");
                const fromBalance = getCoinBalance(tempTo.abbr);
                const toBalance = getCoinBalance(tempFrom.abbr);
                setCoinBalancee(fromBalance);
                setCoinBalanceeTo(toBalance);
              }}
              disabled={!selectedCoinFromObj || !selectedCoinToObj}
              className="w-10 h-10 rounded-full bg-white dark:bg-[#192025] border-4 border-[#E7EBEE] dark:border-[#303030] flex items-center justify-center transition-transform active:scale-90 hover:rotate-180 duration-300 disabled:opacity-40"
              aria-label="Reverse swap direction"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.5 3.75v16.5M4.75 16.5l3.75 3.75 3.75-3.75" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" className="text-secondary_button"/>
                <path d="M15.5 20.25V3.75M11.75 7.5l3.75-3.75 3.75 3.75" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" className="text-secondary_button"/>
              </svg>
            </button>
          </div>
          <div className="w-full py-6 mt-6">
            <div className="flex justify-between gap-4 items-center">
              <div className="w-2/5">
                <h4 className="text-[13px] text-gray-700 dark:text-gray-300">
                  To
                </h4>
                <div className="h-[48px] mt-2 rounded-xl border border-gray-300 dark:border-gray-600 px-2 flex gap-1 justify-start items-center">
                  {selectedCoinToObj && (
                    <div className="flex justify-center items-center  w-[24px] h-[20px] rounded-full">
                      <img
                        src={
                          selectedCoinToObj?.logo ? selectedCoinToObj?.logo : ""
                        }
                        className="w-full h-full bg-cover"
                        alt=""
                      />
                    </div>
                  )}
                  <select
                    value={selectedCoinToObj?.abbr || ""}
                    onChange={handleCoinToChange}
                    className="outline-none w-full text-[14px] bg-transparent text-gray-800 dark:text-gray-200"
                  >
                    <option value="" disabled>
                      Select a coin
                    </option>
                    {swappableCoins
                      .filter((coin: any) => {
                        if (selectedCoinFromObj?.abbr === "USDT")
                          return coin.abbr !== "USDT";
                        return coin.abbr === "USDT";
                      })
                      .map((coin: any, index: any) => (
                        <option key={index} value={coin.abbr}>
                          {coin.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="w-3/5 mt-4">
                <div className="h-[48px] mt-2 rounded-xl border border-gray-300 dark:border-gray-600 px-2  flex gap-1 justify-between items-center">
                  <div className="text-gray-700 dark:text-gray-300 text-[13px] text-left outline-none">
                    {!recieveAmount ? (
                      <h4>Amount</h4>
                    ) : (
                      <h4>{formatAmount(recieveAmount)}</h4>
                    )}
                  </div>
                  <div className="text-[13px] font-bold text-secondary_button">
                    {isLoading ? (
                      <ClipLoader color="#0B84CB" size={20} />
                    ) : (
                      <h4>{selectedCoinToObj?.abbr}</h4>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="text-[13px] flex justify-start text-gray-500 ">
              {coinBalanceeTo !== null && coinBalanceeTo !== undefined && (
                <h4 className="text-center mt-1 text-[11px] font-medium text-gray-700 dark:text-gray-300">
                  Balance:{" "}
                  <span className="text-green-700">
                    {formatAmount(coinBalanceeTo)}{" "}
                    {selectedCoinToObj?.abbr || ""}
                  </span>
                </h4>
              )}
            </div>
          </div>
        </div>
        <button
          disabled={disabled}
          onClick={() => {
            setOpenSwap(false);
            setOpenSwapPreview(true);
          }}
          className={
            disabled
              ? "mt-12 bg-gray-400 flex justify-center items-center text-gray-200 text-[15px] font-medium h-[48px] w-full rounded-xl"
              : "mt-12 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl"
          }
        >
          Proceed
        </button>
      </div>
    </div>
  );
};

export default SwapCoin;
